import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { FiltersStore } from "./FiltersStore";
import { onError } from "@/utils/onError";
import { SearchFilter } from "@/components/filters";
// FR-003: tariff pair list store (UC701). Backs TariffsPage.
export class TariffsStore {
    constructor(tariffService) {
        this.tariffService = tariffService;
        this.loading = false;
        this.initializeFilters = () => {
            const filterItems = [
                {
                    id: "tariff-pair-search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по названию тарифа...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 1,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: { search: "" },
            dataLoader: {
                loadData: (params) => this.loadPairs(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadPairs(params) {
        return this.tariffService.getPairs({
            page: params.page,
            pageSize: params.pageSize,
            filters: params.filters,
            sorters: params.sorters,
        });
    }
    async deletePair(advanceId) {
        this.setLoading(true);
        try {
            await this.tariffService.softDeletePair(advanceId);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Не удалось удалить тариф");
        }
        finally {
            this.setLoading(false);
        }
    }
}
